import { defineStore } from "pinia";

export const notifStore = defineStore("notif", {
  state: () => {
    return {
      title: "",
      message: "",
      autoHide: 0,
      kind: "",
      visible: false,
    };
  },

  actions: {
    create(notif) {
      this.title = notif.title;
      this.message = notif.message;
      this.kind = notif.kind;
      this.visible = true;
      this.autoHide = notif.autoHide;
    },

    show() {
      this.visible = true;
    },

    hide() {
      this.visible = false;
      this.message = "";
    },
  },
});